import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

export function GroupsScreen() {
    return html`
        <div id="groups-screen" class="screen" style="display: none;">
            <h2>Groups</h2>

            <div class="groups-management">
                <div class="schedule-controls">
                    <div class="tabs">
                        <button id="tab-my-groups" class="tab-btn active">My Groups</button>
                        <button id="tab-browse-groups" class="tab-btn">Browse Groups</button>
                        <button id="tab-admin-groups" class="tab-btn">Admin</button>
                    </div>
                </div>

                <div id="view-my-groups" class="groups-view">
                    <div class="groups-header-actions">
                        <button id="create-group-btn" class="btn btn-primary">
                            <svg viewBox="0 0 24 24" width="18" height="18" style="margin-right: 8px;">
                                <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                            </svg>
                            Create New Group
                        </button>
                    </div>
                    <div id="groups-list-container" class="groups-list-container">
                        <div class="empty-state">Loading groups...</div>
                    </div>
                </div>

                <div id="view-browse-groups" class="groups-view" style="display: none;">
                    <p class="browse-description">Discover and join groups.</p>
                    <div class="groups-search-box">
                        <div class="groups-search-row">
                            <div class="groups-search-input-wrap">
                                <svg viewBox="0 0 24 24" width="18" height="18" class="groups-search-icon">
                                    <path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                                </svg>
                                <input type="text" id="groups-search-input" placeholder="Search groups by name..." />
                            </div>
                            <button id="groups-near-me-btn" class="btn btn-primary groups-near-me-btn">
                                <svg viewBox="0 0 24 24" width="18" height="18" style="margin-right: 6px;">
                                    <path fill="currentColor" d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-7z"/>
                                </svg>
                                Near Me
                            </button>
                        </div>
                        <div id="groups-location-status" class="groups-location-status" style="display: none;"></div>
                    </div>
                    <div id="browse-groups-container" class="groups-list-container">
                        <div class="empty-state">Loading groups...</div>
                    </div>
                </div>

                <div id="view-admin-groups" class="groups-view" style="display: none;">
                    <p class="admin-description">Manage groups where you are an admin.</p>
                    <div id="admin-groups-container" class="groups-list-container">
                        <div class="empty-state">Loading groups...</div>
                    </div>
                </div>
            </div>
        </div>
    `;
}
